import { isNil } from 'lodash-es';
import type React from 'react';
import type { IconType } from 'react-icons';

import { IoChevronDown } from 'react-icons/io5';

interface MenuSubitemProps {
  active: boolean;
  label: string;
  additionalStyle?: string;
  icon?: IconType;
  iconSize?: number;
  notificationsAmount?: number;
  submenus?: boolean;
}

const MenuSubitem: React.FC<MenuSubitemProps> = ({
  label,
  active,
  additionalStyle,
  icon: Icon,
  iconSize,
  notificationsAmount,
  submenus,
}) =>
  active ? (
    <div
      className={`px-4 py-2 pl-10 font-semibold transition ${
        additionalStyle || 'hover:bg-slate-200'
      } flex w-full max-w-full cursor-pointer flex-row items-center justify-start gap-[6px] text-sm text-slate-700`}
    >
      <span className="flex max-w-full grow flex-row items-center justify-start">
        {Icon && <Icon size={iconSize ?? 12} className="mr-2" />}
        <span className="line-clamp-1 flex grow flex-row items-center justify-start overflow-hidden text-ellipsis">
          {label}
        </span>
        {submenus && <IoChevronDown size={iconSize ?? 16} />}
      </span>
      {!isNil(notificationsAmount) && notificationsAmount > 0 && (
        <span className="flex flex-row items-center justify-center rounded-full bg-sky-600 px-1 text-xs font-extrabold text-white">
          {notificationsAmount > 99 ? '99+' : notificationsAmount}
        </span>
      )}
    </div>
  ) : (
    <div
      className={`bg-slate-100 px-4 py-2 pl-10 font-semibold ${
        additionalStyle || ''
      } flex w-full max-w-full flex-row items-center justify-start gap-[6px] text-sm`}
    >
      <span className="flex max-w-full grow flex-row items-center justify-start">
        {Icon && <Icon size={iconSize ?? 16} className="mr-2" />}
        <span className="line-clamp-1 flex grow flex-row items-center justify-start overflow-hidden text-ellipsis">
          {label}
        </span>
        {submenus && <IoChevronDown size={iconSize ?? 16} />}
      </span>
      {!isNil(notificationsAmount) && notificationsAmount > 0 && (
        <span className="flex flex-row items-center justify-center rounded-full bg-slate-500 px-1 text-xs font-extrabold text-white">
          {notificationsAmount > 99 ? '99+' : notificationsAmount}
        </span>
      )}
    </div>
  );

export default MenuSubitem;
